<template>
  <VContainer fluid class="py-0 ma-0" style="background: #3D4A6D">
    <VRow class="pa-8 py-0 secondary">
      <VCol cols="12" class="secondary d-flex justify-center py-0 mt-10">
        <VCard color="secondary" variant="flat" class="pa-0">
          <VImg
            :src="titleNegativo"
            style="max-width: 600px; margin: 0 auto;"
          />
          <VCardText class="d-none d-lg-block text-white text-h3 font-weight-black text-center mt-8">
            {{ $t('HOME.slogan') }}
          </VCardText>
          <VCardText class="d-md-none text-white text-h6 text-center">
            {{ $t('HOME.slogan') }}
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script>
import titleNegativo from '@/assets/icons/title_negativo.png'

export default {
  name: 'TitleRP',
  data: () => ({
    titleNegativo
  })
}
</script>
